<ng-container>
    <div class="important-message"
         [ngClass]="message.severity === 'notice' ? 'message-notice' : 'message-warning'"
         *ngFor="let message of messages">
        <span class="fa" [ngClass]="message.severity === 'notice' ? 'fa-refresh' : 'fa-warning'"></span>
        <span *ngIf="message.id < 0" [innerHtml]="message.content"></span><!-- CuzkPasswordValidity messages contain HTML link -->
        <span *ngIf="message.id >= 0">{{message.content}}</span>
    </div>
</ng-container>
